import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import Swal from "sweetalert2";
import {
  candidatesAppliedDetails,
  candidatesDetails,
} from "../Actions/CandidateAction";
import Shimmer from "../Common/Shimmer";
import { CandidateProfile } from "./CandidateProfile";

export const CandidateAppliedDetails = () => {
  const details = useParams();
  const [candidateDetails, setcandidateDetails] = useState(null);
  useEffect(() => {
    candidatesAppliedDetails({
      drive_id: details.drive_id,
      candidate_id: details.candidate_id,
      job_id: details.job_id,
    })
      .then((res) => {
        if (res.error)
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: res.message,
          });
        else setcandidateDetails(res.data[0]);
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: err,
        });
      });
  }, []);
  return candidateDetails ? (
    <CandidateProfile
      candidateDetails={candidateDetails}
      notShowOfferLetter={true}
    />
  ) : (
    <Shimmer />
  );
};
